import React, {useState} from "react";

import {i18n} from "translate/i18n";

import {useNavigate, useParams} from "react-router";
import {Form, Field, Formik} from "formik";
import {useQuery} from "react-query";
import {toast} from "react-toastify";

import {createIndicator, updateIndicator} from "../actions";

import {getIndicator, getIndicatorInformation} from "services/Indicators.service";
import {useTags} from "store/providers/tags";

import {useUser} from "store/providers/app";
import ModalComment from "components/Modal/modalComment";
import Editor from "components/Editor";
import {SelectTags} from "components/Select";
import {groupBy} from "utils/actions";
import {getCommentsById} from "services/Comments.service";
import Loading from "../../../components/Loading";

import Steps from "../../../components/Steps";
import {format, parseISO} from "date-fns";
import {InfoPopover} from "../../../components/InfoPopover";


const INITIAL_VALUES = {
    status: '',
    codigo: '',
    titulo: '',
    contexto: '',
    year_reference: '',
    orientacoes: '',
    racional: '',
    informacoes_complementares: '',
    links: '',
    auditable: false,
}

export default function FormCollect() {

    let {id} = useParams();
    const {user} = useUser();

    const {tags, tagListLang, includeTags, handleChange, clearTags, getTagsLang} = useTags();
    const navigate = useNavigate();

    const [show, setShow] = useState(false)
    const [dataModal, setDataModal] = useState({})
    const [formValues, setFormValues] = useState(INITIAL_VALUES);
    const [comments, setComments] = useState([])
    const [users, setUsers] = useState([])
    const [informations, setInformations] = useState([])


    const {isFetching} = useQuery(["indicator", id],
        () => {
            return getIndicator(id)
        }, {
            onSuccess: (response) => {

                if (user.profile === 2 || user.profile === 3) {
                    const verify = response.users.filter(item => item.user_id.includes(user.id))

                    if (!verify.length) {
                        toast.error('Você não tem permissão para ver este indicador!')
                        navigate('/')
                    }
                }

                clearTags()

                if (response) {
                    setFormValues(
                        {
                            id: response.id,
                            status: i18n.t(`header.${response.status}`),
                            statusDb: response.status,
                            codigo: response.codigo,
                            titulo: response.titulo,
                            year_reference: response?.year_reference,
                            contexto: response?.contexto,
                            racional: response.racional ?? '',
                            informacoes_complementares: response?.informacoes_complementares,
                            links: response.links ?? '',
                            orientacoes: response.orientacoes ?? '',
                            language: response.language ?? 'pt-BR',
                            created: response.created_at,
                            updated: response.updated_at,
                            auditable: response.auditable
                        }
                    );

                    getTagsLang(response.language)
                    includeTags(response.tags)
                    setUsers(response.users)
                }
            },
            onError: () => {
                toast.error('Erro ao acessar indicador');
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )

    const {isFetching: isFetchingInformation} = useQuery(["information_indicator", id],
        () => {
            return getIndicatorInformation({indicator_id: id, reference: ''})
        }, {
            onSuccess: (response) => {
                setInformations(response)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )


    const filterHelper = (reference) => {
        if (informations.length > 0 && reference !== '') {
            const find = informations.find(information => information.reference === reference)
            if (find) {
                return find
            }
            return ''
        }
        return ''
    }

    const {data} = useQuery(["comments_indicator", id],
        () => {
            return id && getCommentsById(id)
        }, {
            onSuccess: (response) => {

                if (response) {
                    let commentsIndicator = groupBy(response, 'type_input')

                    commentsIndicator = {
                        ...commentsIndicator,
                        'total_context': commentsIndicator['context']?.filter(item => item.resolved === 0).length
                    }
                    commentsIndicator = {
                        ...commentsIndicator,
                        'total_data_year': commentsIndicator['data_year']?.filter(item => item.resolved === 0).length
                    }
                    commentsIndicator = {
                        ...commentsIndicator,
                        'total_racional': commentsIndicator['racional']?.filter(item => item.resolved === 0).length
                    }
                    commentsIndicator = {
                        ...commentsIndicator,
                        'total_info_complement': commentsIndicator['info_complement']?.filter(item => item.resolved === 0).length
                    }

                    setComments(commentsIndicator)
                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )

    const View = ({label, children}) => {
        return (
            <div className="form-group">
                <label className="form-label">{label}</label>
                {children}
            </div>
        )
    }

    const ViewButton = ({param, total, label}) => {

        if (!id) return null

        return (
            <button type="button" className={`btn btn-primary position-relative py-3 ${!id && 'disabled'}`}
                    onClick={() => handleOpenModal(param, label)}>
                Comentários
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {total ? total : 0}
                </span>
            </button>
        )
    }

    const ViewSelect = ({label, children, name, selected}) => {
        return (
            <div className="form-group mt-2">
                <div className="d-flex gap-2">
                    <label className="form-label">{label}</label>
                    <InfoPopover
                        label={label}
                        info={filterHelper(name)}
                        referenceInput={name}
                    />
                </div>

                <SelectTags
                    items={tagListLang[name]}
                    selected={selected}
                    handleChange={handleChange}
                    name={name}
                />

                {children}
            </div>
        )
    }

    const handleOpenModal = (param, label) => {
        setDataModal({
            param,
            label
        })
        setShow(true)
    }

    const handleClose = () => {
        setShow(!show);
    }

    if (isFetching) {
        return <Loading/>
    }

    if (user.profile === 7 && !formValues.auditable) {
        toast.error('Você não tem permissão para acessar este indicador!');
        navigate('/')
    }


    if (user.profile === 7 && formValues.statusDb !== 'finished') {
        toast.error('Você não tem permissão para acessar este indicador!');
        navigate('/')
    }

    if (isFetching) return <>Aguarde</>

    return (
        <div>
            <ModalComment
                show={show}
                handleClose={handleClose}
                data={dataModal}
                usersIndicator={users}
                indicator={formValues.codigo + ' - ' + formValues.titulo}
            />

            <Formik
                initialValues={formValues}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    if (user.profile !== 7) {
                        id ? updateIndicator(values, tags, user.username) :
                            createIndicator(values, tags, user.username).then((response) => {
                                navigate(`/collect/indicator/edit/${response.indicator.id}`)
                                toast.success('Indicador criado com sucesso!')
                            })
                    } else {
                        toast.error('Ação não permitida para o seu perfil!')
                    }
                }}
            >
                {({
                      values,
                      setFieldValue,
                  }) => (

                    <Form>
                        {formValues.created &&
                            <div className="pt-4 px-3 d-grid gap-3">
                                <div className="row gap-2 text-sm">
                                    <div
                                        className="col-12 col-md-3 ms-md-3 bg-secondary align-self-center rounded py-1 text-sm">
                                        Criado
                                        em: {formValues.created && format(parseISO(formValues.created), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="col-12 col-md-3 bg-secondary align-self-center rounded py-1">
                                        Atualizado
                                        em: {formValues.updated && format(parseISO(formValues.updated), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="col align-self-end">
                                        <Steps
                                            statusIndicator={formValues.statusDb}
                                            idDb={id}
                                        />
                                    </div>

                                </div>
                            </div>
                        }

                        <div className="p-3 d-grid gap-3">
                            <div className="row">
                                <div className="col-2">
                                    <View label="Ano de referência">
                                        <Field
                                            as="select"
                                            className="form-select"
                                            name="year_reference"
                                            required
                                            disabled={user.profile === 3}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                            <option value="2025">2025</option>
                                        </Field>
                                    </View>
                                </div>
                                <div className="col-2">
                                    <View label="Código">
                                        <Field
                                            className="form-control"
                                            name="codigo"
                                            required
                                            disabled={user.profile === 3}
                                        />
                                    </View>
                                </div>
                                <div className="col-xl-8">
                                    <View label={i18n.t('stage.title')}>
                                        <Field
                                            className="form-control"
                                            name="titulo"
                                            required
                                            disabled={user.profile === 3}
                                        />
                                    </View>
                                </div>
                            </div>

                            {id &&
                                <>
                                    {
                                        user.profile !== 3 && user.profile !== 2 &&
                                        <>
                                            <h5>{i18n.t('stage.tags')}</h5>

                                            <div className="row mb-3">
                                                <div className="col-12 col-md-6">
                                                    <ViewSelect label="Temas Materiais" name='temas_materiais'
                                                                selected={tags?.temas_materiais}/>

                                                    <ViewSelect label="Hashtag" name='hashtag'
                                                                selected={tags?.hashtag}/>

                                                    <ViewSelect label="ODS" name='ods' selected={tags?.ods}>

                                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                                            {tags?.ods.map(item =>
                                                                <img
                                                                    key={item.label}
                                                                    src={window.location.origin + `/assets/img/certificados/ODS_${item.label}.png`}
                                                                    alt={`ODS_${item.label}`}
                                                                    width={60}/>
                                                            )}
                                                        </div>
                                                    </ViewSelect>

                                                    <ViewSelect label="Dimensão GRI" name='dimensao_gri'
                                                                selected={tags?.dimensao_gri}/>

                                                    <ViewSelect label="Código GRI" name='codigo_gri'
                                                                selected={tags?.codigo_gri}/>

                                                </div>

                                                <div className="col-12 col-md-6">

                                                    <ViewSelect label="Dimensão SASB" name='dimensao_sasb'
                                                                selected={tags?.dimensao_sasb}/>

                                                    <ViewSelect label="Código SASB" name='codigo_sasb'
                                                                selected={tags?.codigo_sasb}/>

                                                    <ViewSelect label="Setor SASB" name='setor_sasb'
                                                                selected={tags?.setor_sasb}/>

                                                    <ViewSelect label="Dimensão Métrica do capitalismo
                                                Stakeholder" name='dim_m_c_stakeholder'
                                                                selected={tags?.dim_m_c_stakeholder}/>

                                                    <ViewSelect label="TCFD" name='tcfd' selected={tags?.tcfd}/>

                                                    <ViewSelect label="Compromissos" name='flag_compromissos'
                                                                selected={tags?.flag_compromissos}/>

                                                </div>
                                            </div>

                                        </>
                                    }
                                </>
                            }

                            <div className="row align-items-end">
                                <div className="col-12">
                                    <div className="form-group mb-0">
                                        <div className="d-flex gap-2">
                                            <label className="form-label">
                                                Orientações para preenchimento do indicador (Informação internas)
                                            </label>
                                            <InfoPopover
                                                label="Orientações"
                                                info={filterHelper('orientations')}
                                                referenceInput="orientations"
                                            />
                                        </div>

                                        <Field
                                            as="textarea"
                                            className="form-control"
                                            name="orientacoes"
                                            disabled={user.profile === 3}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group mb-0">
                                <div className="d-flex gap-2">
                                    <label className="form-label">
                                        Links dos indicadores publicados no ciclo 2021 (Gestão interna) - Use para te
                                        apoiar no preenchimento deste indicador
                                    </label>
                                    <InfoPopover
                                        label="Links"
                                        info={filterHelper('links')}
                                        referenceInput="links"
                                    />
                                </div>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values?.links}
                                    name="links"
                                    disabled={user.profile === 3}
                                />
                            </div>

                            <div className="row align-items-end">
                                <div className="col-12 col-md-10">
                                    <div className="form-group mb-0">
                                        <div className="d-flex gap-2">
                                            <label className="form-label d-flex">
                                                Contexto
                                            </label>
                                            <InfoPopover
                                                label="Contexto"
                                                info={filterHelper('context')}
                                                referenceInput="context"
                                            />
                                        </div>

                                        <Editor
                                            handleChange={setFieldValue}
                                            data={values?.contexto}
                                            name="contexto"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-2 d-grid">
                                    <ViewButton
                                        param="context"
                                        label="Contexto"
                                        total={comments?.total_context}
                                    />
                                </div>
                            </div>

                            <div className="row align-items-end">
                                <div className="col-12 col-md-10">
                                    <div className="form-group mb-0">
                                        <div className="d-flex gap-2">
                                            <label className="form-label">Qual o racional utilizado para esta
                                                informação? De onde você coletou esta informação?</label>
                                            <InfoPopover
                                                label="Racional"
                                                info={filterHelper('rational')}
                                                referenceInput="rational"
                                            />
                                        </div>

                                        <Field
                                            as="textarea"
                                            className="form-control"
                                            name="racional"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-2 d-grid">
                                    <ViewButton
                                        param="racional"
                                        label="Racional Utilizado"
                                        total={comments?.total_racional}
                                    />
                                </div>
                            </div>

                            <div className="row align-items-end">
                                <div className="col-12 col-md-10">
                                    <div className="form-group mb-0">
                                        <div className="d-flex gap-2">
                                            <label className="form-label">Informações complementares</label>
                                            <InfoPopover
                                                label="Info. Complementares"
                                                info={filterHelper('complements')}
                                                referenceInput="complements"
                                            />
                                        </div>
                                        <Editor handleChange={setFieldValue}
                                                data={values?.informacoes_complementares}
                                                name="informacoes_complementares"/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-2 d-grid">
                                    <ViewButton
                                        param="info_complement"
                                        label="Informações complementares"
                                        total={comments?.total_info_complement}
                                    />
                                </div>
                            </div>

                            {user.profile === 1 &&
                                <div className="card p-3 mt-3">
                                    <div className="form-check form-check-custom form-switch d-flex align-items-center">
                                        <Field className="form-check-input" type="checkbox" role="switch"
                                               name="auditable"
                                               id="auditable"/>

                                        <div className="d-flex align-items-center">
                                            <label className="form-check-label"> Permitir auditoria</label>
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>

                        {user.profile !== 7 &&
                            <>
                                <hr className="p-0"/>

                                <div className="float-end pb-3 pe-3">
                                    <button className="btn btn-success px-5 py-2"
                                            type="submit">{i18n.t('buttons.save')}</button>
                                </div>
                            </>
                        }

                    </Form>
                )}
            </Formik>
        </div>
    )
}
